import React from 'react'

import { Step, Box, Grid } from '@mui/material'
import { GridStepper } from '@front/squirtle'

import FormHeader from '@abra/elements/headers/Form'
import PrimarySection from './Section/Primary'

const TelephonyProfile = props =>
  <Box sx={{ display: 'flex', justifyContent: 'center' }} px={6}>
    <Grid container rowSpacing={3}>
      <Grid size={12}><FormHeader goBackPath={'/telephonyprofile'} /></Grid>
      <Grid size={12}>
        <GridStepper groupsCount={[3]} activeStep={0} orientation="vertical">
          <Step> <PrimarySection /> </Step>
        </GridStepper>
      </Grid>
    </Grid>
  </Box>

export default React.memo(TelephonyProfile)
